export const property = {
        /**
        * Gets the programmatic name of the entire locale, with the language, 
        *   country and variant separated by underbars. The Language is always lower case, 
        *   and country is always upper case. If the language is missing, 
        *   the string will begin with an underscore character. 
        *   If both the language and country fields are missing, 
        *   this function will return the empty string, 
        *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
        *   the variant must accompany a valid language or country code). Examples: "en"
        *
        */
    en: {
        property:'hierarchy',
        add_property:'Add Hierarchy',
        edit_property:'Edit Hierarchy',
        property_information:'Hierarchy Information',
        property_type:'Hierarchy Type',
        property_sub_type:'Hierarchy Sub Type',
        select_property_type:'Hierarchy Type',
        consumers:'Consumers',
        flat_no:'Flat No',
        tower:'Tower',
        tower_name:'Tower Name',
        area:'Area',
        location:'location',
        select_location:'Select Location',
        city:'City',
        state:'State',
        pincode:'Pincode',
        select_city:'Select City',
        property_status:'Hierarchy Status',
        is_active:'Is Active',
        is_inactive:'Is Inactive',
        property_owner_name:'Owner Name',
        property_owner_email_id:'Owner Email ID',
        property_owner_phone:'Owner Phone',
        property_owner_mobile:'Owner Mobile',
        _occupant:'Occupant',
        occupant_email_id:'Occupant  Email ID',
        sample_file_download:'Sample File Download',
        bulk_upload:'Bulk Upload',
        cancel:'cancel',
        yes:'Yes',
        no:'No',
        property_management:'Hierarchy Management',
        property_id:'Hierarchy ID',
        owner_name:'Owner Name',
        owner_mobile:'Owner Mobile',
        owner_email_id:'Owner Email ID',
        owner_phone:'Owner Phone',
        occupant_name:'Occupant Name',
        occupant_mobile:'Occupant Mobile',
        occupant_phone:'Occupant Phone',
        status:'Status',
        action:'Action',
        select:'Select',
        occupant_status:'occupant Status',
        occupant:{
            occupant_history:'Occupant History',
            occupant_id:'Occupant ID',
            occupant_name:'Occupant Name',
            end_date:'End Date',
            status:'Status',
            action:'Action',
            add_occupant:'Add occupant',
            edit_occupant:'Edit occupant',
            occupent_information:'Occupant Information',
            first_name:'First Name',
            middle_name:'Middle Name',
            last_name:'Last Name',
            email_id:'Email ID',
            phone_number:'Phone Number',
            start_date:'Start Date',
            cancel:'Cancel',
            mobile:'Mobile',
            change_occupant:'Change Occupant',
        },
        property_type_management: "Hierarchy Type Management",
        property_sub_type_management: "Hierarchy Sub Type",
        property_subtype: "Hierarchy SubType",
        add_property_type: "Add Hierarchy Type",
        add_property_type_information: "Add Hierarchy Type Information",
        edit_property_type: "Edit Hierarchy Type",
        property_type_id: "Hierarchy Type ID",
        property_type_name: "Hierarchy Type Name",
        property_type_information: "Hierarchy Type Information",
        property_type_status: "Status",
        add_property_sub_type: "Add Hierarchy Sub Type",
        edit_property_sub_type: "Edit Hierarchy Sub Type",
        property_sub_type_id: "Hierarchy Sub Type ID",
        property_sub_type_name: "Hierarchy Sub Type Name",
        property_sub_type_information: "Hierarchy Sub Type Information",
        property_sub_type_status: "Status",
        hierarchy_title: 'Hierarchy Title',
        label:"Label",
        data_type:"Data Type",
        hierarchy:"Hierarchy",
        change_occupant_hint:"Choose yes if you want to change occupant",
        name:'Name',
        email_id:'Email ID',
        mobile_number:'Mobile Number',
        address:'Address',
        delete_confrim_msg:"Are you sure you want to delete this hierarchy?",
        sub_type:{
            add:{
                success: 'Hierarchy sub type added successfully',
                error: 'Unable to add property sub type. Please try again',
            },
            get:{
                error: 'Unable to find the data. Please try again'
            },
            edit:{
                success: 'Hierarchy sub type updated successfully',
                error: 'Unable to update property sub type. Please try again',
            }
        },
        type:{
            add:{
                success: 'Hierarchy type added successfully',
                error: 'Unable to add property type. Please try again',
            },
            get:{
                error: 'Unable to find the data. Please try again'
            },
            edit:{
                success: 'Hierarchy type updated successfully',
                error: 'Unable to update property type. Please try again',
            }
        },
        property_name:'Hierarchy',
        property_project_name:'Project',
    },

    ar: {
        property:'التسلسل الهرمي',
        add_property:'أضف التسلسل الهرمي',
        edit_property:'تحرير التسلسل الهرمي',
        property_information:'معلومات التسلسل الهرمي',
        property_type:'نوع التسلسل الهرمي',
        property_sub_type:'النوع الفرعي التسلسل الهرمي',
        select_property_type:'نوع التسلسل الهرمي',
        consumers:'المستهلكون',
        flat_no:'رقم الشقة',
        tower:'البرج',
        tower_name:'اسم البرج',
        area:'المنطقة',
        location:'الموقع',
        select_location:'اختر موقعا',
        city:'المدينة',
        state:'الحالة',
        pincode:'الرمز السري',
        select_city:'اختر مدينة',
        property_status:'حالة التسلسل الهرمي',
        is_active:'نشط',
        is_inactive:'غير نشط',
        property_owner_name:'اسم المالك',
        property_owner_email_id:'معرف البريد الإلكتروني للمالك',
        property_owner_phone:'هاتف المالك',
        property_owner_mobile:'رقم الهاتف المحمول للمالك',
        _occupant:'الساكن',
        occupant_email_id:'معرف البريد الإلكتروني للساكن',
        sample_file_download:'نموذج تنزيل ملف',
        bulk_upload:'رفع مجمع',
        cancel:'إلغاء',
        yes:'نعم',
        no:'لا',
        property_management:'إدارة التسلسل الهرمي',
        property_id:'معرف التسلسل الهرمي',
        owner_name:'اسم المالك',
        owner_mobile:'رقم الهاتف المحمول للمالك',
        owner_email_id:'معرف البريد الإلكتروني للمالك',
        owner_phone:'معرف البريد الإلكتروني للمالك',
        occupant_name:'اسم الساكن',
        occupant_mobile:'رقم الهاتف المحمول للساكن',
        occupant_phone:'هاتف الساكن',
        status:'الحالة',
        action:'الوظيفة',
        select:'اختيار',
        occupant_status:'حالة المقيم',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذه الخاصية؟",
        occupant:{
            occupant_history:'تسجل الساكن',
            occupant_id:'معرف الساكن',
            occupant_name:'اسم الساكن',
            end_date:'تاريخ الانتهاء',
            status:'الحالة',
            action:'الوظيفة',
            add_occupant:'إضافة ساكن',
            edit_occupant:'تحرير ساكن',
            occupent_information:'معلومات الساكن',
            first_name:'الاسم الأول',
            middle_name:'الاسم الأوسط',
            last_name:'الكنية',
            email_id:'الايميل',
            phone_number:'رقم الهاتف',
            start_date:'تاريخ البدء',
            cancel:'الغاء',
            mobile:'الهاتف المحمول',
            change_occupant:'تغيير الساكن',
        },
        property_type_management: "إدارة نوع التسلسل الهرمي",
        property_sub_type_management: "النوع الفرعي التسلسل الهرمي",
        property_subtype: "النوع الفرعي التسلسل الهرمي",
        add_property_type: "أضف نوع التسلسل الهرمي",
        add_property_type_information: "إضافة معلومات نوع التسلسل الهرمي",
        edit_property_type: "تحرير نوع التسلسل الهرمي",
        property_type_id: "معرف نوع التسلسل الهرمي",
        property_type_name: "اسم نوع التسلسل الهرمي",
        property_type_information: "معلومات نوع التسلسل الهرمي",
        property_type_status: "الحالة",
        add_property_sub_type: "إضافة نوع فرعي هرمي",
        edit_property_sub_type: "تحرير النوع الفرعي التسلسل الهرمي",
        property_sub_type_id: "معرف النوع الفرعي التسلسل الهرمي",
        property_sub_type_name: "اسم النوع الفرعي التسلسل الهرمي",
        property_sub_type_information: "معلومات النوع الفرعي التسلسل الهرمي",
        property_sub_type_status: "الحالة",
        hierarchy_title: 'عنوان التسلسل الهرمي',
        label:"ملصق",
        data_type:"نوع البيانات",
        hierarchy:"التسلسل الهرمي",
        change_occupant_hint:"اختر نعم إذا كنت تريد تغيير الساكن",
        name:'الاسام',
        email_id:'الايميل',
        mobile_number:'رقم الهاتف المحمول',
        address:'العنوان',
        sub_type:{
            add:{
                success: 'تمت إضافة النوع الفرعي للتسلسل الهرمي بنجاح',
                error: 'تعذر إضافة النوع الفرعي للممتلكات. حاول مرة اخرى',
            },
            get:{
                error: 'تعذر العثور على البيانات. حاول مرة اخرى'
            },
            edit:{
                success: 'تم تحديث النوع الفرعي للتسلسل الهرمي بنجاح',
                error: 'تعذر تحديث نوع الخاصية الفرعي. حاول مرة اخرى',
            }
        },
        type:{
            add:{
                success: 'تمت إضافة نوع التدرج الهرمي بنجاح',
                error: 'تعذر إضافة نوع الخاصية. حاول مرة اخرى',
            },
            get:{
                error: 'تعذر العثور على البيانات. حاول مرة اخرى'
            },
            edit:{
                success: 'تم تحديث نوع التدرج الهرمي بنجاح',
                error: 'تعذر تحديث نوع الخاصية. حاول مرة اخرى',
            }
        },
        property_name:'التسلسل الهرمي',
        property_project_name:'المشروع',
    }
}

